import React from "react";
import crypto from 'crypto';
import { UserRound } from "lucide-react";

// Paleta de colores similar a la de Google
const GOOGLE_AVATAR_COLORS = [
  "#1E8E3E", // Verde oscuro
  "#EA4335", // Rojo Google
  "#FBBC05", // Amarillo
  "#4285F4", // Azul Google
  "#34A853", // Verde claro
  "#A142F4", // Púrpura
  "#F09300", // Naranja
  "#C5221F", // Rojo oscuro
];

// Función para calcular un color basado en un string (nombre/correo)
const getGoogleAvatarColor = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return GOOGLE_AVATAR_COLORS[Math.abs(hash) % GOOGLE_AVATAR_COLORS.length]; // Selección del color
};

// Función para generar colores
const generarColor = (texto:string) => {
  const hash = crypto.createHash('md5').update(texto).digest('hex');
  const color = `#${hash.substring(0, 6)}`;
  return color;
};


const Avatar = ({ user, className }:{ user:any, className:string }) => {
  
  const name = ''+(user?.displayName??user?.email)
  const initials = name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase();
   
  const nameView = name.trim()[0]
    .toUpperCase();
  
  const bgColor = getGoogleAvatarColor(initials);
//<div className="rounded-full bg-gray-100 w-10 h-10 rounded-full text-xl p-3 pt-1 pb-1 border border-slate-300" >{user?.displayName?.charAt(0).toUpperCase()??user?.email?.charAt(0).toUpperCase()}</div>

  return (
     user.isAnonymous?
       
        <UserRound className={`bg-slate-600 text-white rounded-full p-1 ${className}`} strokeWidth={1}  />
     
     :
    <div
      className={`flex text-xl items-center justify-center border border-slate-300 text-white ${className}`}
      style={{ backgroundColor: bgColor }}
    >
      {nameView}
    </div>
  );
};

export default Avatar;
